import createSagaMiddleware from "redux-saga";
import { createBrowserHistory } from "history";
import { createStore, applyMiddleware, compose, combineReducers } from "redux";
import { routerMiddleware, connectRouter } from "connected-react-router";
import { persistStore, persistReducer, createMigrate } from "redux-persist";
import storage from "redux-persist/lib/storage"; // defaults to localStorage for web and AsyncStorage for react-native

import rootSagas from "./rootSagas";
import rootReducer, { allReducersName } from "./rootReducer";
import {
  createFilter,
  createBlacklistFilter
} from "redux-persist-transform-filter";

// create middlewares
const history = createBrowserHistory();
const sagaMiddleware = createSagaMiddleware();

const middleware = applyMiddleware(routerMiddleware(history), sagaMiddleware);

const blacklistFilters = [
  "loading",
  "requesting",
  "definitionRequesting",
  "selectedManagerNoteIndex",
  "uploading"
];

const allBlacklistFilters = allReducersName.reduce((prev, curr) => {
  const saveSubsetBlacklistFilter = createBlacklistFilter(
    curr,
    blacklistFilters
  );
  prev.push(saveSubsetBlacklistFilter);
  return prev;
}, []);

// migration config
const migrations = {
  0: state => state
};

const persistConfig = {
  key: "root",
  version: -1,
  storage,
  migrate: createMigrate(migrations),
  transforms: allBlacklistFilters
};

// create store
const composeEnhancers = window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || compose;
const persistedReducer = persistReducer(persistConfig, rootReducer);

const store = createStore(
  connectRouter(history)(persistedReducer),
  composeEnhancers(middleware)
);
// const store = createStore(
//   connectRouter(history)(rootReducer),
//   /* preloadedState, */ composeEnhancers(middleware)
// );
const persistor = persistStore(store);
// run saga middleware
sagaMiddleware.run(rootSagas);

export { store };
export { persistor };
export { history };
